var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.587,123.452V6.866L66.506,140.956h116.578C195.682,140.956,200.587,136.05,200.587,123.452z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.844,460.372c-3.029,3.493-2.946,22.185-2.649,51.628h45.255c-10.136-17.876-22.278-34.012-30.938-44.966 C357.513,467.034,350.024,455.643,345.844,460.372z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.4,107.148c-19.556,36.316-30.492,70.84-29.451,75.801c1.013,4.933,4.246,8.148,13.416,2.378 c3.902-2.444,19.129-10.824,36.688-23.514V75.792C444.36,85.631,437.17,96.463,431.4,107.148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.897,288.878c7.303-1.514,83.401-41.593,141.318-71.825c31.839-100.913,71.1-165.445,108.81-194.664 C451.867,10.024,441.769,0,429.356,0h-202.84v139.051c0,15.339-12.486,27.834-27.816,27.834H59.947v61.614 c41.974,6.281,93.546,34.728,138.475,60.379C199.844,289.018,201.042,289.056,201.897,288.878z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.1,302.815c0,0-67.179-29.238-106.153-28.81v62.534c3.131-0.195,6.234-0.362,9.709-0.855 C99.933,331.41,175.53,304.738,166.1,302.815z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.608,380.354c0,0,15.961-97.458,24.917-122.579c-22.65,14.995-107.639,53.29-107.639,53.29 S298.351,368.267,308.608,380.354z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350.099,418.472c26.645,32.582,51.033,66.994,66.019,93.528h13.239c12.514,0,22.696-10.183,22.696-22.697 V193.075c-17.048,11.595-37.84,24.508-61.41,37.366C372.155,290.412,357.708,370.998,350.099,418.472z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.451,322.511c-53.718,22.222-108.885,37.078-132.399,40.497c-3.168,0.464-6.104,0.725-9.104,1.059v125.236 c0,12.514,10.192,22.697,22.696,22.697h215.178c-0.037-27.723,2.184-60.25,7.172-98.275 C277.168,384.005,240.602,348.552,201.451,322.511z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfLogo);
export default __webpack_public_path__ + "static/media/pdf-logo.3dbf47179c7623c36cada378e73b2c68.svg";
export { ForwardRef as ReactComponent };